import { queryKeys } from '../api/query-keys';
import type { EventMap } from '../api/signalr';
import { ALL_CLUB_MONEY_KEYS } from '../money/refreshAfterMoney';

type Topic = keyof EventMap;

export const INVALIDATION_MAP: Partial<Record<Topic, ReadonlyArray<readonly unknown[]>>> = {
  BookingCreated: [
    ['schedule'],
    ['schedule-range'],
    ['bookings'],
    ['dashboard'],
    ['trainer'],
  ],
  BookingCancelled: [
    ['schedule'],
    ['schedule-range'],
    ['bookings'],
    ['dashboard'],
    ['trainer'],
  ],
  BookingRescheduled: [
    ['schedule-range'],
    ['bookings'],
    ['trainer'],
  ],
  BookingConfirmed: [
    ['schedule'],
    ['schedule-range'],
    ['bookings'],
    ['dashboard'],
    ['trainer'],
  ],
  BookingExtensionChanged: [
    ['schedule'],
    ['schedule-range'],
    ['trainer'],
  ],
  TrainerScheduleChanged: [
    ['trainer'],
    ['trainers'],
    ['trainers-floor'],
    ['trainer-availability'],
    ['schedule'],
    ['schedule-range'],
    ['bookings'],
    ['group-sessions'],
  ],
  ScheduleBlockChanged: [['schedule']],
  CourtCatalogChanged: [['settings', 'courts'], ['schedule'], ['schedule-range'], queryKeys.resources.all()],
  TournamentCreated: [['tournaments'], ['tournament'], ['schedule']],
  TournamentRescheduled: [['tournaments'], ['tournament'], ['schedule']],
  TournamentCancelled: [['tournaments'], ['tournament'], ['schedule']],
  TournamentStatusChanged: [['tournaments'], ['tournament']],
  TournamentBracketGenerated: [['tournaments'], ['tournament']],
  TournamentRoundStarted: [['tournaments'], ['tournament']],
  TournamentRoundCompleted: [['tournaments'], ['tournament']],
  TournamentCompleted: [['tournaments'], ['tournament']],
  TournamentPlayerRegistered: [['tournaments'], ['tournament']],
  TournamentPlayerUnregistered: [['tournaments'], ['tournament']],
  MatchScoreUpdated: [['tournaments'], ['tournament']],

  PosSaleConfirmed: [...ALL_CLUB_MONEY_KEYS],
  RefundCompleted: [...ALL_CLUB_MONEY_KEYS],

  OpenMatchChanged: [['matchmaking']],
  GroupSessionChanged: [['group-sessions']],

  AccessEntry: [['access']],
  AccessDenied: [['access']],

  TaskCreated: [['tasks'], ['dashboard']],
  TaskUpdated: [['tasks'], ['dashboard']],
  TaskCompleted: [['tasks'], ['dashboard']],
  AssistanceCreated: [['assistance'], ['dashboard']],
  AssistanceUpdated: [['assistance']],

  ChatMessage: [['chat']],

  NotificationCreated: [['notifications']],
};

export type InvalidationTopic = keyof typeof INVALIDATION_MAP;
